"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MartiniGlassOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path fill-rule="evenodd" d="M6.283 6H19.68l2.501-3.573a1 1 0 1 1 1.638 1.147L22.12 6h3.595c.872 0 1.326 1.038.735 1.678L16.996 17.92c.002.026.003.053.003.08v8h4a1 1 0 0 1 0 2H11a1 1 0 1 1 0-2h4v-8c0-.027.001-.053.003-.08L5.548 7.678C4.958 7.038 5.411 6 6.283 6zm9.143 7.82a1 1 0 0 1-.246-1.393L18.279 8H8.567L16 16.051l7.432-8.05H20.72l-3.902 5.572a1 1 0 0 1-1.392.246z" clip-rule="evenodd" stroke="none"></path>';
var MartiniGlassOutlineSVG = function MartiniGlassOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.MartiniGlassOutlineSVG = MartiniGlassOutlineSVG;
MartiniGlassOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(MartiniGlassOutlineSVG);
exports.default = _default;